import React, { useEffect, useState } from 'react'
import { NavLink, useLocation, useParams } from 'react-router-dom'
import { Calendar, Task, Community, LearningCenter } from './Icons'
import './Styles/side-bar.css'

const usePageViews = () => {
  const location = useLocation()
  const [currentPath, setPath] = useState(window.location.pathname)
  useEffect(() => {
    setPath(location.pathname)
  }, [location])
  return currentPath
}

const SidenavButton = ({ href, id, text, icon, currentPath }) => {
  const { cardId } = useParams()
  return (
    <NavLink
      to={href}
      className='sidenav-item'
      activeClassName={currentPath === href || cardId !== null ? 'sidenav-active' : 'sidenav-item'}
      id={id}
    >
      {icon}
      {text}
    </NavLink>
  )
}

const SideBar = ({ expanded }) => {
  const currentPath = usePageViews()

  return (
    <div
      className='sidenav'
      style={{ width: `${expanded ? '222px' : '80px'}` }}
    >
      <SidenavButton
        currentPath={currentPath}
        href='/events'
        id='myEvents'
        text={expanded ? <label className='full'> My events </label> : ''}
        icon={<Calendar />}
      />

      <SidenavButton
        currentPath={currentPath}
        href='/activities'
        id='activities'
        text={expanded ? <label className='full'> Activities </label> : ''}
        icon={<Task />}
      />

      <SidenavButton
        currentPath={currentPath}
        href='/community'
        id='community'
        text={expanded ? <label className='full'> Community </label> : ''}
        icon={<Community />}
      />

      <SidenavButton
        currentPath={currentPath}
        href='/learning-center'
        id='learningCenter'
        text={expanded ? <label className='full'> Learning center </label> : ''}
        icon={<LearningCenter />}
      />
    </div>
  )
}

export default SideBar
